import { connect } from 'react-redux';
import AdminTable from 'layouts/AdminTable';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { fetchMealTypes } from 'actions/MealTypes';
import { fetchVariants } from 'actions/Variants';
import { fetchDiets } from 'actions/Diets';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormSelectSingle from 'components/FormSelect/FormSelectSingle';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import axios from 'helpers/gastro';
import { get } from 'helpers/apiHelpers';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { apiErrorToast } from 'utils/apiError';
import MenuSummaryWeekPicker from 'components/MenuSummaryWeekPicker/MenuSummaryWeekPicker';

import { ROLE_SHOW_MENU_SUMMARY } from '../../../helpers/roles';
import { isGranted } from '../../../helpers/helpers';
import SummaryContent from './SummaryContent';

const SummaryV2 = ({
  variants: givenVariants,
  diets,
  classes,
  t,
  i18n,
  match,
  brand,
  variants,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchMealTypes,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchVariants,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchDiets,
}) => {
  const [state, setState] = useState({
    date: moment().startOf('week'),
    variant: '',
    lockedExport: false,
    loading: false,
    menuPlanners: [],
  });

  const summaryRequestIdRef = useRef(0);
  const isUnmountedRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([fetchMealTypes(), fetchVariants(), fetchDiets()]);

      if (typeof match.params.date !== 'undefined') {
        await setState(prevState => ({
          ...prevState,
          date: moment(match.params.date).startOf('week'),
        }));
      }

      if (typeof match.params.variant !== 'undefined') {
        const variant = variants.find(
          // eslint-disable-next-line no-shadow -- FIXME
          variant => variant.id === match.params.variant
        );
        if (variant) {
          await setState(prevState => ({
            ...prevState,
            variant,
          }));
        }
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  useEffect(
    () => () => {
      isUnmountedRef.current = true;
    },
    []
  );

  useEffect(() => {
    const fetchMenuPlanners = async () => {
      if (!state.variant || state.variant === '') {
        summaryRequestIdRef.current += 1;

        if (state.menuPlanners.length > 0 || state.loading) {
          setState(prev => ({ ...prev, menuPlanners: [], loading: false }));
        }

        return;
      }

      const requestId = summaryRequestIdRef.current + 1;
      const weekStart = moment(state.date).startOf('week');
      const weekEnd = moment(state.date).endOf('week');

      summaryRequestIdRef.current = requestId;
      setState(prev => ({ ...prev, loading: true }));

      try {
        const response = await get('/menu-summary', {
          pagination: false,
          'date[after]': weekStart.format('YYYY-MM-DD'),
          'date[before]': weekEnd.format('YYYY-MM-DD'),
          variant: state.variant['@id'],
          properties: ['id', 'mealType', 'diet', 'date'],
          'properties[dish]': 'nameForClient',
          draft: false,
        });

        if (
          isUnmountedRef.current ||
          requestId !== summaryRequestIdRef.current
        ) {
          return;
        }

        setState(prev => ({
          ...prev,
          menuPlanners: response['hydra:member'],
          loading: false,
        }));
      } catch (error) {
        if (
          isUnmountedRef.current ||
          requestId !== summaryRequestIdRef.current
        ) {
          return;
        }

        apiErrorToast(t('menuPlanner.errors.somethingGoWrong'), error);
        setState(prev => ({ ...prev, menuPlanners: [], loading: false }));
      }
    };

    fetchMenuPlanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.variant, state.date]);

  const getArrayOfDays = () => {
    const array = [];

    array.push(state?.date?.format('YYYY-MM-DD'));
    // eslint-disable-next-line no-plusplus -- FIXME
    for (let i = 1; i < 7; i++) {
      const date = moment(state?.date?.format('YYYY-MM-DD')).add('days', i);
      const key = date.locale('en').format('dddd').toLowerCase();

      if (brand[key] !== 0) {
        array.push(date.format('YYYY-MM-DD'));
      }
    }

    return array;
  };

  const modifyDate = (add = true) => {
    setState(prevState => ({
      ...prevState,
      date: prevState.date.clone().add(add ? 7 : -7, 'days'),
    }));
  };

  const handleWeekChange = selectedWeekStart => {
    setState(prev => ({ ...prev, date: selectedWeekStart }));
  };

  const handleSelectChange = (event, value) => {
    setState(prev => ({
      ...prev,
      variant: value,
    }));
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  const exportToPDF = date => {
    setState(prevState => ({ ...prevState, lockedExport: true }));

    const params = {
      'date[after]': getArrayOfDays()[0],
      'date[before]': getArrayOfDays()[6],
      variant: state.variant.id,
    };

    axios
      .get('reports/menu-planner', {
        responseType: 'blob',
        params,
        headers: { accept: 'application/pdf' },
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `Planowanie-menu-${getArrayOfDays()[0]}-${
              getArrayOfDays()[6]
            }_(${moment().format('YYYY-MM-DD_HH.mm')}).pdf`
          );

          document.body.appendChild(link);
          link.click();
          setState(prevState => ({ ...prevState, lockedExport: false }));
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(t('reports.cannotGenerate'), error);
          setState(prevState => ({ ...prevState, lockedExport: false }));
        }
      );
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  const exportToXLSX = date => {
    setState(prevState => ({ ...prevState, lockedExport: true }));

    const params = {
      'date[after]': getArrayOfDays()[0],
      'date[before]': getArrayOfDays()[6],
      variant: state.variant.id,
      weekView: true,
    };

    axios
      .get('reports/menu-planner', {
        responseType: 'blob',
        params,
        headers: { accept: 'application/vnd.ms-excel' },
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `Planowanie-menu-${getArrayOfDays()[0]}-${
              getArrayOfDays()[6]
            }_(${moment().format('YYYY-MM-DD_HH.mm')}).xlsx`
          );

          document.body.appendChild(link);
          link.click();
          setState(prevState => ({ ...prevState, lockedExport: false }));
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(t('reports.cannotGenerate'), error);
          setState(prevState => ({ ...prevState, lockedExport: false }));
        }
      );
  };

  const filteredDiets = state.variant
    ? diets.filter(diet => state.variant.diets.includes(diet['@id']))
    : [];

  return isGranted(ROLE_SHOW_MENU_SUMMARY) ? (
    <AdminTable title={t('form.menuPlanning.menuSummary')}>
      <GridContainer>
        <GridItem md={4} style={{ textAlign: 'right' }}>
          <Button
            color="info"
            round={true}
            onClick={() => {
              modifyDate(false);
            }}
            disabled={state.loading}
          >
            <KeyboardArrowLeft /> {t('form.menuPlanning.prevWeek')}
          </Button>
        </GridItem>
        <GridItem md={4} style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '15px' }}>
            <MenuSummaryWeekPicker
              locale={i18n.language}
              onChange={handleWeekChange}
              value={state.date}
            />
          </div>
          {state.loading && (
            <GridItem md={12} style={{ textAlign: 'center' }}>
              <CircularProgress />
            </GridItem>
          )}
          <FormSelectSingle
            classes={classes}
            options={givenVariants.map(v => {
              // eslint-disable-next-line no-negated-condition -- FIXME
              if (!v.active) {
                v.displayName = v.name + t('form.menuPlanning.inactive');
              } else {
                v.displayName = v.name;
              }

              return v;
            })}
            mapBy="displayName"
            trackBy="@id"
            value={state.variant}
            handleChange={handleSelectChange}
            label={t('form.menuPlanning.selectVariant')}
          />
        </GridItem>
        <GridItem md={4} style={{ textAlign: 'left' }}>
          <Button
            color="info"
            round={true}
            onClick={() => {
              modifyDate(true);
            }}
            disabled={state.loading}
          >
            {t('form.menuPlanning.nextWeek')}
            <KeyboardArrowRight />
          </Button>
        </GridItem>
      </GridContainer>
      {filteredDiets.length > 0 && !state.loading && (
        <GridContainer>
          <GridItem md={12} style={{ textAlign: 'center' }}>
            {state.lockedExport && (
              <GridItem md={12} style={{ textAlign: 'center' }}>
                <CircularProgress />
              </GridItem>
            )}
            {!state.lockedExport && (
              <Button
                color="primary"
                round={true}
                onClick={() => {
                  exportToPDF();
                }}
                disabled={state.loading}
              >
                {t('form.menuPlanning.saveWeekPdf')}
              </Button>
            )}
            {!state.lockedExport && (
              <Button
                color="primary"
                round={true}
                onClick={() => {
                  exportToXLSX();
                }}
                disabled={state.loading}
              >
                {t('form.menuPlanning.saveWeekExcel')}
              </Button>
            )}
          </GridItem>
        </GridContainer>
      )}
      <div style={{ overflow: 'auto' }}>
        <SummaryContent
          date={state.date}
          variant={state.variant}
          diets={filteredDiets}
          dates={getArrayOfDays()}
          loading={state.loading}
          menuPlanners={state.menuPlanners}
        />
      </div>
    </AdminTable>
  ) : null;
};

const mapStateToProps = state => ({
  variants: state.Variants.variants,
  diets: state.Diets.diets,
  brand: state.Brands.brand,
});

const mapDispatchToProps = dispatch => ({
  fetchMealTypes: () => dispatch(fetchMealTypes()),
  fetchVariants: () => dispatch(fetchVariants()),
  fetchDiets: () => dispatch(fetchDiets({ 'order[internalPosition]': 'ASC' })),
});

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(buttonsStyle)(SummaryV2))
);
